import { useState } from 'react';
import { FaCalendarAlt, FaClock, FaUserAlt } from "react-icons/fa";
import { GiTennisCourt } from "react-icons/gi";
import { MdError} from "react-icons/md";
import { Tooltip } from '@mui/material';
import axios from 'axios';
import dayjs from 'dayjs';
import ShowBookingModal from '../../components/ShowBookingModal';
import { API_BASE_URL } from '../../App.js';
import useFetchData from '../../hooks/useFetchData.jsx';


const Bookings = () => {
    const [bookings, setBookings] = useState([]);
    const [players, setPlayers] = useState([]);
    const [familyMember, setFamilyMember ] = useState([]);
    const [selectedBooking, setSelectedBooking] = useState(null);
    const [showBooking, setShowBooking] = useState(false);

    useFetchData({
    endpoint: '/api/allBookings',
    setter: setBookings,
    transformFn: data => data.filter(b => dayjs(b.startTime).isAfter(dayjs()) && b.gameType !== 'event')
  });

  useFetchData({
    endpoint: '/api/players',
    setter: setPlayers
  });

  useFetchData({
    endpoint: '/api/allfamilymember',
    setter: setFamilyMember
  });

    const getPlayerName = (playerId, snapshot) => {
        const player = players.find(p => p.id === playerId);
        return player ? `${player.name}` : (snapshot || 'Spieler gelöscht');
    };

    const getPartnerName = (partnerIds, partnerSnapshots = []) => {
        const firstPartnerId = partnerIds[0];
        const partner = (players.find(p => p.id === firstPartnerId ) || familyMember.find(p => p._id === firstPartnerId));
        
        return partner ? `${partner.name}` : (partnerSnapshots[0] || 'Unbekannter Partner');
    };

    const handleClick = (booking) => {
        setSelectedBooking(booking);
        setShowBooking(true);
    };

    const handleClose = (value) => {
        setShowBooking(false);
        if (value) {
            axios.get(`${API_BASE_URL}/api/allBookings`)
                .then((response) => {
                    const now = dayjs();
                    const futureBookings = response.data.filter(booking => dayjs(booking.startTime).isAfter(now) && booking.gameType !== 'event');
                    setBookings(futureBookings);
                })
                .catch((error) => {
                    console.error("Fehler beim Abrufen der Buchungen: ", error);
                });
        }
    };

    return (
        <div className='bg-white rounded shadow-sm pb-2'>
            <div className='text-center pt-3 fw-semibold fs-4 text-danger'>Buchungen</div>

            {/* Tabellen Header */}
            <div className='px-2 text-center pb-4 mt-3'>
                <div className='row mx-0 justify-content-center pb-2 infotext legende'>
                    <div className='col-3 col-md-2'><FaCalendarAlt size={22} /></div>
                    <div className='col-2 d-none d-md-block'><FaClock size={25} /></div>
                    <div className='col-7 col-md-3'><FaUserAlt size={22} /></div>
                    <div className='col-3 d-none d-md-block'><FaUserAlt size={22} /></div>
                    <div className='col-2'><GiTennisCourt size={26} /></div>
                </div>

                {/* Rendern der Buchungen */}
                {bookings.length === 0 ? (
                    <div className='text-center'>Keine zukünftigen Buchungen gefunden.</div>
                ) : (
                    bookings.map((booking, index) => (
                        <div key={index} 
                             className={`row mx-0 justify-content-center py-2 my-1 booking border-top ${booking.status === 1 ? 'opacity-75' : ''}`} 
                             onClick={() => handleClick(booking)}
                             style={booking.status === 1 ? { backgroundColor: '#fff5f5' } : {}}
                        >
                            <div className='col-3 col-md-2 text-dark d-flex align-items-center justify-content-center fs-7'>
                                {booking.status === 1 && (
                                    <Tooltip title={`Storniert wegen: ${booking.cancelledByEventId?.name || 'Unbekannt'}`}>
                                        <span style={{ marginRight: '4px', cursor: 'help' }}>
                                            <MdError color="#d32f2f" size={18} />
                                        </span>
                                    </Tooltip>
                                )}
                                {dayjs(booking.startTime).format("DD.MM.YY")}
                            </div>
                            <div className='col-2 fs-7 d-none d-md-block'>
                                {dayjs(booking.startTime).format("HH:mm")} - {dayjs(booking.endTime).format("HH:mm")}
                            </div>
                            <div className='col-7 col-md-3 fs-7'>{getPlayerName(booking.playerId, booking.playerSnapshot)}</div>
                            <div className='col-3 d-none d-md-block fs-7'>{getPartnerName(booking.partners, booking.partnersSnapshot)}</div>
                            <div className='col-2 fs-7'>{booking.courtId}</div>
                        </div>
                    ))
                )}
            </div>
            {/* Modal für Buchungsdetails */}
            <ShowBookingModal 
                show={showBooking} 
                onHide={handleClose} 
                booking={selectedBooking} 
                players={players} 
            />
        </div>
    );
};

export default Bookings;
